// @flow
import React from 'react';
import classNames from 'classnames/bind';

import OverflowedText from 'app/common/components/OveflowedText';

import styles from './StatementsListItem.scss';


const cx = classNames.bind(styles);

type Props = {
  title: string,
  id: number,
  number: string,
  date: string,
  active?: boolean,
  disabled?: boolean,
}

const StatementsListItem = ({
  title,
  number,
  date,
  active = false,
  disabled = false,
}: Props) => (
  <span className={cx(styles.root, { active, disabled })}>
    <span className={styles.firstLine}>
      <OverflowedText className={styles.number}>
        {number}
      </OverflowedText>
      <span className={styles.date}>
        {date}
      </span>
    </span>
    <span className={styles.secondLine}>
      <OverflowedText className={styles.secondLineContent}>
        {title}
      </OverflowedText>
    </span>
  </span>
);

export default StatementsListItem;
